// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__-VOds","load8":"Spinner_load8__1qdSW"};